"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerMutations = exports.customerMutationKeys = void 0;
const customer_api_1 = require("./customer.api");
exports.customerMutationKeys = {
    all: () => ['customer'],
    updateEmail: () => [...exports.customerMutationKeys.all(), 'updateEmail'],
    sendPasswordResetEmail: () => [...exports.customerMutationKeys.all(), 'sendPasswordResetMail'],
    createAccount: () => [...exports.customerMutationKeys.all(), 'createAccount'],
};
const customerMutations = (apiOptions) => ({
    updateEmailMutation: (options = {}) => (Object.assign(Object.assign({}, options), { mutationKey: exports.customerMutationKeys.updateEmail(), mutationFn: (params) => (0, customer_api_1.updateEmail)(apiOptions, params) })),
    sendPasswordResetEmailMutation: (options = {}) => (Object.assign(Object.assign({}, options), { mutationKey: exports.customerMutationKeys.sendPasswordResetEmail(), mutationFn: (params) => (0, customer_api_1.sendPasswordResetEmail)(apiOptions, params) })),
    createAccountMutation: (options = {}) => (Object.assign(Object.assign({}, options), { mutationKey: exports.customerMutationKeys.createAccount(), mutationFn: (params) => (0, customer_api_1.createAccount)(apiOptions, params) })),
});
exports.customerMutations = customerMutations;
//# sourceMappingURL=customer.mutations.js.map